import React, { useEffect, useState } from 'react';
import { TypeDocument } from "../../utils/TypeDocument.js";
import ColorsMain from "../../colors/ColorsMain.js";

const SelectDocument = ({ setValue, error = false, type = "" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [shouldRender, setShouldRender] = useState(false); // Controla si el menú debería renderizarse o no
    const [selectedOption, setSelectedOption] = useState("CC");
    const [hoveredButton, setHoveredButton] = useState(null);

    const options = TypeDocument.es;


    const handleOptionClick = (option) => {
        if (type == "") {
            setValue(option.code)

        } else {
            setValue(option.id)

        }
        setSelectedOption(option.code);
        setIsOpen(false); // Cierra el menú después de seleccionar una opción
    };

    // Controla la apertura del menú con un retraso suave
    useEffect(() => {
        if (isOpen) {
            const openTimer = setTimeout(() => {
                setShouldRender(true); // Mostrar el div con retraso para la animación
            }, 100); // Pequeño retraso de 100ms para una apertura más suave
            return () => clearTimeout(openTimer); // Limpia el temporizador si isOpen cambia
        } else {
            const closeTimer = setTimeout(() => {
                setShouldRender(false); // Ocultar el div después de la animación de cierre
            }, 500); // Asegúrate que coincida con la duración de la transición
            return () => clearTimeout(closeTimer);
        }
    }, [isOpen]);

    // Cierra automáticamente después de 10 segundos
    useEffect(() => {
        if (isOpen) {
            const autoCloseTimer = setTimeout(() => {
                setIsOpen(false);
            }, 10000);
            return () => clearTimeout(autoCloseTimer);
        }
    }, [isOpen]);

    return (
        <div className="relative inline-block text-left">
            {/* Botón que simula el input select */}
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="inline-flex justify-between w-22 px-2 py-2 font-medium rounded-md items-center transition-colors duration-300 ease-in-out"
                style={{ background: ColorsMain.bgInput, color: ColorsMain.texttMain, borderWidth: 1, borderColor: error ? ColorsMain.errorBorder : ColorsMain.borderGray }}
            >
                {selectedOption}
                <svg
                    className={`w-5 h-5 transition-transform duration-500 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {/* Renderizar el div solo cuando shouldRender sea true */}
            {shouldRender && (
                <div
                    className={`absolute mt-2 w-80 shadow-lg ring-opacity-5 z-10 rounded-xl transition-all duration-500 transform ${isOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
                        }`}
                    style={{ background: ColorsMain.bgInput }}
                >
                    <div className="max-h-60 overflow-y-auto rounded-xl px-2 pt-2">
                        <div className="rounded-xl">
                            {options.map((option, index) => (
                                <button
                                    onMouseEnter={() => setHoveredButton(index)}
                                    onMouseLeave={() => setHoveredButton(null)}
                                    key={index}
                                    onClick={() => handleOptionClick(option)}
                                    className="w-full text-left text-smz h-11 flex"
                                    style={{
                                        background: hoveredButton === index ? ColorsMain.bgHover : ColorsMain.bgInput,
                                        color: ColorsMain.texttMain,
                                        borderTopRightRadius: index === 0 ? 14 : 0,
                                        borderTopLeftRadius: index === 0 ? 14 : 0,
                                        padding: 8,
                                        borderRadius: hoveredButton === index ? 12 : 0,
                                    }}
                                >
                                    <div className='flex items-center justify-center w-8 h-8 mr-2 rounded-lg' style={{ background: ColorsMain.bgOpacity }}>
                                        <p className=' text-center' >{option.code}</p>
                                    </div>
                                    <p>{option.label}</p>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SelectDocument;
